var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.isReach ? _vm.searchData.length : null
  var g1 = _vm.regionList.length
  var g2 = _vm.hotcites.length
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.inputValue = ""
    }
    _vm.e1 = function ($event) {
      _vm.isReach = false
    }
    _vm.e2 = function ($event) {
      _vm.isReach = true
    }
    _vm.e3 = function ($event) {
      _vm.isToggle = !_vm.isToggle
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }